export const faqData = [
  {
    question: "What is Tracker!",
    answer: `<div>
  <p><strong>A tool Trainees and their BCBA Supervisors Need.</strong></p>
  <p>The purpose of supervision is to improve the trainee's behavior-analytic skills, professionalism, and ethical skills. Also, to ensure the delivery of high-quality services to clients.</p>
  <h4>Effective behavior-analytic supervision involves:</h4>
  <ul>
    <li>Monitoring the Trainee's Skills</li>
    <li>Setting Performance Expectations</li>
    <li>Providing Behavioral-Skills Training</li>
    <li>Observing the Trainee's Performance with Clients</li>
    <li>Modeling Professional and Ethical Behavior</li>
    <li>Guiding the Trainee's Development of Case Conceptualization
      <ul>
        <li>problem-solving skills</li>
        <li>reviewing written materials</li>
        <li>overseeing service delivery</li>
        <li>evaluating the effects of supervision</li>
      </ul>
    </li>
  </ul>

  <h4>The responsibilities of the supervisor include:</h4>
  <ul>
    <li>Being knowledgeable about and compliant with all requirements set forth by the Behavior Analyst Certification Board (BACB) relating to fieldwork</li>
    <li>Confirming that the trainee has met all requirements before starting supervised fieldwork</li>
    <li>Demonstrating technical, professional, and ethical behavior</li>
    <li>Ensuring that fieldwork activities are in the best interest of the client</li>
    <li>Providing supervision only within their areas of competence</li>
    <li>Delegating responsibilities to trainees only when they can reasonably perform them competently and ethically</li>
    <li>Ensuring that supervision and fieldwork activities are behavior-analytic in content and meet licensure or certification requirements</li>
    <li>Providing a clear written description of the purpose, requirements, and terms of supervision</li>
    <li>Designing feedback and reinforcement systems to improve trainee performance</li>
  </ul>

  <p>The supervisor is also responsible for providing ongoing documented feedback to the trainee and obtaining evaluation of their own supervision activities.</p>

  <p><strong>Tracker!</strong> Helps the trainee complete the required documentation set forth by the BACB (<em>#BCBAHandbook</em>) while giving you feedback if you have not met the minimum requirements OR have exceeded requirements (e.g., max hours per month, number of contacts with your supervisor, etc.). It takes away the fear of an audit and allows you to be in the driver seat for supervision. Making the process more enjoyable and giving you the time back that you lose to endless Excel documents — ensuring that you’re documenting your hours correctly.</p>
</div>
`,
  },
  {
    question: "What are the restricted and unrestricted hours?",
    answer: `<div><p>Restricted activities may comprise no more than 40% of the total fieldwork hours—
    this requirement does not need to be met during each supervisory period.
    Please note that this restriction does not necessarily refer to all time spent working with clients.
  </p>

  <p><strong>WTF is unrestricted?</strong><br>Pretty much any activity that is away from direct work with clients <em>and</em> is behavior analytic in nature.</p>

  <p>These things are 99% of what you will do in the future as a BCBA.</p>

  <p><strong>Examples:</strong></p>
  <ul>
    <li>Observation</li>
    <li>Training</li>
    <li>Data collection</li>
    <li>Conducting assessments</li>
    <li>Writing</li>
    <li>Graphing</li>
    <li>Research</li>
  </ul>

  <p><strong>Non-examples:</strong></p>
  <ul>
    <li>School stuff</li>
    <li>Administrative tasks</li>
    <li>Non-behavioral tasks</li>
    <li>Crisis management</li>
  </ul>
</div>
`,
  },
  {
    question: "How long do I store my documents from supervision?",
    answer: "7 years.",
  },
  {
    question: "What is considered a supervision contact?",
    answer:
      "If your supervisor was present then this counts towards you supervision contact per supervisory period (4 contacts needed for supervised, 6 contacts needed concentrated). : A real-time interaction between the supervisor and trainee that takes place in an individual or group format.",
  },
  {
    question: "How often do I have to meet with my supervisor?",
    answer: `<div style='margin-top: 5px;'><strong>Supervised:</strong> 5% of your fieldwork hours have to be supervised by your supervisor!<br><strong>Concentrated:</strong> 10% of your fieldwork hours have to be supervised by your supervisor!</p></div>`,
  },
  {
    question: "What is discussed in supervision?",
    answer:
      "Great question! Your supervisor can follow a curriculum BUT we suggest using our task list grid to ensure that all topics are taught in supervision. #fluency Did you know the more you practice each task list topic, utilizing behavior skills training, you’ll become competent. We think 10 opportunities within each topics the gold ticket. Work smarter not harder babe. And use our proprietary grid to watch your hard work unfold!",
  },
  {
    question:
      "How often do I have to fill our my monthly verification form? What do I do with these forms?",
    answer:
      "Monthly! BACB states you’ve got 30 days from the end of the month to get that thing completed. Just follow our prompts under Fieldwork Forms and upload the MVF to Tracker!",
  },
  {
    question:
      "Supervision is so stressful... how can I make it less overwhelming?",
    answer:
      `<div>
  <p><strong>WOULDN’T IT BE NICE TO SIT FOR THE BCBA EXAM AND FEEL CONFIDENT KNOWING YOU HAD THE TRAINING FOR EACH TASK-LIST TOPIC?</strong><br>
  Tracker! Does that for you.</p>

  <p><strong>WOULDN’T IT BE NICE TO SIGN INTO ONE PLATFORM THAT STORES YOUR NOTES, ALLOWS YOUR SUPERVISOR TO ANALYZE AND APPROVE YOUR DOCUMENTATION IN REAL-TIME, AND STORE ALL MONTHLY AND FINAL VERIFICATION FORMS?</strong></p>

  <p>An efficient and effective fieldwork process as well as an organized documentation system will help ensure that all relevant documents remain secure while keeping both you as the Trainee or Supervisor up-to-date on the progress being made throughout the course training.</p>

  <p><strong>Tracker!</strong> Is the system that keeps stress at bay and everyone enjoying the process.</p>
</div>
`
  },
  {
    question:
      "How long will the supervision process take from start to finish?",
    answer:
      "Supervision can be completed in as short as 12 months , but often 18 months is the average. 1500-2000 hours have to be accrued throughout this process and the number of hours is determined by what is offered through your supervisor, some are able to accommodate 5% supervision and others 10% supervision",
  },
];
